/**
 * Page Footer Component
 *
 * Compact PumpFun-style footer with legal text left, links centered.
 * Single row on desktop, stacked on mobile.
 */

import { LEGAL_LINKS, EXTERNAL_LINKS } from '@/lib/constants/navigation';

export function PageFooter() {
  return (
    <footer className="py-4 px-4 border-t border-border/50 mt-auto">
      <div className="relative flex flex-col sm:flex-row items-center justify-center sm:justify-between gap-2 sm:gap-0 text-xs text-muted-foreground">
        {/* Legal Text - Left on desktop, bottom on mobile */}
        <span className="order-2 sm:order-1">
          © DexToro Trading Inc. 2026
        </span>

        {/* Links - Center with pipe separators */}
        <div className="flex items-center gap-1.5 order-1 sm:order-2 sm:absolute sm:left-1/2 sm:-translate-x-1/2">
          <a
            href={LEGAL_LINKS.privacy}
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-foreground transition-colors"
          >
            Privacy
          </a>
          <span className="text-muted-foreground/40">|</span>
          <a
            href={LEGAL_LINKS.terms}
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-foreground transition-colors"
          >
            Terms
          </a>
          <span className="text-muted-foreground/40">|</span>
          <a
            href={EXTERNAL_LINKS.status}
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-foreground transition-colors"
          >
            Status
          </a>
        </div>

        {/* Spacer for flex alignment on desktop */}
        <span className="hidden sm:block order-3 w-[140px]" aria-hidden="true" />
      </div>
    </footer>
  );
}
